/**
 * Central route path registry. Import these constants instead of hardcoding
 * path strings so links and the router never drift apart.
 */
export const routePaths = {
  // Public / auth
  login: '/login',
  authCallback: '/auth/callback',
  authStart: '/auth/start',
  register: '/register',
  forgotPassword: '/forgot-password',

  // Protected app
  home: '/',
  /** Post-login email verification (ProtectedRoute sends unverified accounts here). */
  verifyEmail: '/verifica-email',
  appointments: '/programari',
  newAppointment: '/programare-noua',
  results: '/rezultate',
  patients: '/pacienti',
  addPatient: '/adauga-pacient',
  attachedAccounts: '/conturi',
} as const;

export type RoutePath = (typeof routePaths)[keyof typeof routePaths];
